import React, { useContext } from "react";
import { useIsDesktop } from "../../../../lib/hooks/mediaQueries";
import { Button } from "../../../Button";
import NavigationMenuContext from "../../NavigationMenuContext";

import t from "../../../../lib/translate";

import * as styles from "./subNavigationAside.module.less";

export function SubNavigationAside() {
    const isMobile = useIsDesktop();
    const {
        navigationReducer: {
            navState: {
                activeLayer: { name: activeLayerName, level, link, externalUrl }
            },
            dispatch
        },
        setIsBackLink
    } = useContext(NavigationMenuContext);

    return (
        <div className={styles.asideContainer}>
            {(level > 1 || isMobile) && (
                <Button
                    className={styles.backButton}
                    type="secondary"
                    icon="chevronLeft"
                    iconPosition={'left'}
                    onClick={() => {
                        setIsBackLink(true)
                        dispatch({ type: "back" })
                    }}
                >
                    {t("navigation.button.back")}
                </Button>
            )}
        </div>
    );
}
